import ABCyaLib from "@abcya/abcya_lib";
import ABCyaPhaser from "@abcya/abcya_phaser";

export default class SetItemData
{
    // Handles setting phaser specific gameobject data for
    // the newly placed object
    // Handles back button presses
    // Handles back log editing after objects are moved back to tray
    // Plays Letters and number sounds based on frame.name
    constructor(scene)
    {
        this.scene = scene;
    }

    SetItemData(Temp,OriginalAsset,Tab,ActionType = "Place")
    {
        var Action = "Place";

        //console.log(Tab.getData('TabName'));

        if (ActionType === "Place")
        {
            Temp.setData(
                {
                    Id: this.scene.Id,
                    TrayX: OriginalAsset.x, 
                    TrayY: OriginalAsset.y,
                    TabName: Tab.getData('TabName'),
                    TabX: Tab.x,
                    TabY: Tab.y
                });

            this.scene.Id++;

            if(Tab.getData('TabName') === "LettersTray")
            {
                let sound = Temp.text.toLowerCase();
                console.log(Temp.text.toLowerCase());
                ABCyaPhaser.Audio.playOneShot(sound, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
            }

            else if(Tab.getData('TabName') === "NumbersTray")
            {
                //file name is Numbers/{number}_{color}
                //so the number will always be at location 8
                
                switch(Temp.frame.name[8])
                {
                    case '0':
                        ABCyaPhaser.Audio.playOneShot('Zero', this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                        break;
                    case '1':
                        ABCyaPhaser.Audio.playOneShot('One', this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                        break;
                    case '2':
                        ABCyaPhaser.Audio.playOneShot('Two', this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                        break;
                    case '3':
                        ABCyaPhaser.Audio.playOneShot('Three', this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                        break;
                    case '4':
                        ABCyaPhaser.Audio.playOneShot('Four', this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                        break;
                    case '5':
                        ABCyaPhaser.Audio.playOneShot('Five', this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                        break;
                    case '6':
                        ABCyaPhaser.Audio.playOneShot('Six', this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                        break;
                    case '7':
                        ABCyaPhaser.Audio.playOneShot('Seven', this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                        break;
                    case '8':
                        ABCyaPhaser.Audio.playOneShot('Eight', this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                        break;
                    case '9':
                        ABCyaPhaser.Audio.playOneShot('Nine', this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
                        break;
                    default:
                        break;
                }
            }

            else
            {
                this.scene.playSound("place_item");
            }

            if (Temp.frame.name.indexOf("Icing") > -1)
            {
                if(this.scene.Icing === "null")
                {
                    this.scene.Icing = Temp;
                }

                else
                {
                    Temp.setData('PreviousIcing',this.scene.Icing);
                    Temp.setData({OldPlacement: {x: this.scene.Icing.x, y: this.scene.Icing.y}});
                    this.scene.Icing.destroy();
                    this.scene.Icing = Temp;
                    Action = "Replace";
                }
            }
            
            this.CreateBackLog(Action,Temp);
        }
        else
        {
            this.CreateBackLog(ActionType,Temp);
        }

    }

    CreateBackLog(Action, Temp)
    {
        var BackObject = 
        {
            Action: Action,
            Item: Temp,
            Id: Temp.getData('Id'),
            AssetType: Temp.getData('TabName')
        }; 

        if (Action === "Replace")
        {
            let OldPlacement = Temp.getData('OldPlacement');
            BackObject.PreviousIcing = Temp.getData('PreviousIcing');
            BackObject.OldPlacement = {x:0,y:0};
            BackObject.OldPlacement.x = OldPlacement.x;
            BackObject.OldPlacement.y = OldPlacement.y;
        }

        else if (Action === "Move")
        {
            let OldPlacement = Temp.getData('OldPlacement');
            BackObject.OldPlacement = {x:0,y:0};
            BackObject.OldPlacement.x = OldPlacement.x;
            BackObject.OldPlacement.y = OldPlacement.y;
        }

        else if (Action === "Draw")
        {   
            this.scene.CreateRenderLayer();
        }
        
        this.scene.BackLog.push(BackObject);
        //console.log(this.scene.BackLog);
    }

    FireCheck(Temp,Action)
    {
        if(Temp.getData('TabName') === "CandleTray")
            {
                let Fire = Temp.getData('Fire');

                if(Action === "Move")
                {
                    Move(Temp, Fire);
                }
                else if(Action === "Place")
                {
                    Fire.destroy();
                }
                else if(Action === "Drag")
                {
                    Move(Temp,Fire)
                    Fire.setVisible(true);
                }
            }

            function Move(Temp,Fire)
            {
                let TopPoint = Temp.getTopCenter();
                Fire.x = TopPoint.x;
                Fire.y = TopPoint.y;
            }
    }

    MoveBackLogClear(GameObject)
    {
        var BackLogDelete = [];
        var i;
        var x;
        var Increm;
        //console.log(this.scene.BackLog);

        if (GameObject.getData('TabName') != "IcingTray")
        {
            for(x=0; x < this.scene.BackLog.length;x++)
            {
                if(this.scene.BackLog[x].Id === GameObject.getData('Id'))
                {
                    if (this.scene.BackLog[x].Action === "Replace")
                    {
                        for(i=0; i < this.scene.BackLog.length;i++)
                        {
                            if(this.scene.BackLog[i].Id === this.scene.BackLog[x].PrevID)
                            {
                                BackLogDelete.push(i);
                                i = this.scene.BackLog.length;
                            }
                        }
                    }

                    BackLogDelete.push(x);
                    if (GameObject.getData('TabName') === "CandleTray") GameObject.getData('Fire').destroy();
                    this.scene.Animations.TweenItemToTray(GameObject);
                    //console.log(this.scene.BackLog);
                    //x = this.scene.BackLog.length;
                }
            }
        }
        else
        {
            for(x=0; x < this.scene.BackLog.length;x++)
            {
                if(this.scene.BackLog[x].AssetType === "IcingTray")
                {
                    BackLogDelete.push(x);
                }
            }
            this.scene.Animations.TweenItemToTray(GameObject);
            //console.log(this.scene.BackLog);
            this.scene.Icing = 'null';
            //console.log(this.scene.Icing);
        }
        
        BackLogDelete.sort(function(a, b){return b-a});//orders greatest to least, to make sure that the numbers stay the same when deleting
        //console.log(BackLogDelete);
        for (Increm in BackLogDelete)
        {
            this.scene.BackLog.splice(BackLogDelete[Increm],1);
        }
        //console.log(this.scene.BackLog);
    }

    BackButton()
    {
        if (this.scene.BackLog.length > 0)
        {
            this.scene.playSound("undo");
            const CurrentItem = this.scene.BackLog[this.scene.BackLog.length-1];
            switch(CurrentItem.Action)
            {
                case "Move":
                    //console.log(CurrentItem);
                    CurrentItem.Item.x = CurrentItem.OldPlacement.x;
                    CurrentItem.Item.y = CurrentItem.OldPlacement.y;

                    this.FireCheck(CurrentItem.Item,"Move");

                    this.scene.BackLog.pop();
                    break;
                case "Replace":
                    if(this.scene.Icing != "null")
                    {
                        this.scene.Icing.destroy();
                    }

                    this.scene.Icing = this.scene.addImage(CurrentItem.OldPlacement.x, CurrentItem.OldPlacement.y, CurrentItem.PreviousIcing.frame.name);
                    switch(this.scene.Icing.frame.name)
                        {
                            case "Icing/Icing_1":
                                this.scene.Icing.scale = .88;
                                break;
                            case "Icing/Icing_5":
                                this.scene.Icing.scale = .95;
                                break;
                            case "Icing/Icing_6":
                                this.scene.Icing.scale = .95;
                                break;
                            case "Icing/Icing_7":
                                this.scene.Icing.scale = 1.09;
                                break;
                            default:
                                this.scene.Icing.scale = .9;
                                break;
                        }
                    this.scene.Icing.setDepth(this.scene.DepthList.Icing);
                    this.scene.Icing.setInteractive();
                    this.scene.input.setDraggable(this.scene.Icing);
                    this.scene.Icing.setData({
                        Id: CurrentItem.PrevID,
                        TabName: CurrentItem.AssetType,
                        TrayX:220,
                        TrayY:390,
                        TabX: 0,
                        TabY: 192
                    });
                    this.scene.CakeGroup.add(this.scene.Icing);
                    //console.log(this.scene.BackLog);
                    this.scene.BackLog.pop();
                    break;
                case "Draw":
                    this.scene.RenderLog[(this.scene.RenderLog.length - 2)].destroy();
                    this.scene.RenderLog.splice(this.scene.RenderLog.length - 2,1);
                    this.scene.BackLog.pop();
                    break;
                case "Place":
                    if (CurrentItem.AssetType != "IcingTray")
                    {
                        this.FireCheck(CurrentItem.Item,"Place");
                        CurrentItem.Item.destroy();
                    }
                    else
                    {
                        if(this.scene.Icing != "null")
                        {
                            this.scene.Icing.destroy();
                            this.scene.Icing = "null";
                        }
                        //this.scene.BackLog.pop();
                    }
                    this.scene.BackLog.pop();
                    break;
                default:
                    break;
            }
        }
    }
}